import React, { useState } from 'react';
import { Modal, Table, Box, Indicator, ActionIcon, Tooltip } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';



interface Props {
    uniqueWarnings: {
        portfolioId: string;
        messages: string[];
    }[]
}



export const WarningsModal: React.FC<Props> = ({ uniqueWarnings }) => {
    const [opened, setOpened] = useState(false);

    return (
        <>
            <Indicator inline label={`${uniqueWarnings.length}`} disabled={uniqueWarnings.length === 0} color="red" size={16}>
                <Tooltip label="View Warnings" withArrow>
                    <ActionIcon variant='light'
                        c={uniqueWarnings.length === 0 ? undefined : 'red'}
                        onClick={() => setOpened(true)}
                        size='lg'
                        disabled={uniqueWarnings.length === 0}
                    >

                        <IconAlertCircle size={16} />
                    </ActionIcon>
                </Tooltip>
            </Indicator>
            <Modal opened={opened} onClose={() => setOpened(false)} title="Warnings" size="xl">
                <Box style={theme => ({ border: `1px solid ${theme.colors.gray[3]}`, borderRadius: theme.radius.sm })}>
                    <Table striped highlightOnHover verticalSpacing="sm">
                        <Table.Thead>
                            <Table.Tr>
                                <Table.Th ta="center">Portfolio</Table.Th>
                                <Table.Th ta="center">Warning</Table.Th>
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                            {uniqueWarnings.map(p => {
                                const pid = p.portfolioId;

                                return (
                                    <React.Fragment key={pid}>
                                        {p.messages.map((msg, index) => (
                                            <Table.Tr key={index}>
                                                <Table.Td ta="center">{pid}</Table.Td>
                                                <Table.Td ta="center">{msg}</Table.Td>
                                            </Table.Tr>
                                        ))}
                                    </React.Fragment>
                                );
                            })}
                        </Table.Tbody>
                    </Table>
                </Box>
            </Modal>
        </>
    );
};





// Usage example:
// <WarningsModal uniqueWarnings={uniqueWarnings} />
